import {Autocomplete, TextField} from '@mui/material'
import {styled} from '@mui/material/styles'
import _ from 'lodash'
import qs from 'qs'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import useOfficeHierarchy from 'utils/hooks/useOfficeHierarchy'
import {useAuth} from '../../../../_component/modules/auth'
import {envBackHost} from '../../../../GLOBAL/envVariables'
import {axiosWithAuth} from '../../../../helper/axiosWithAuth'
import './asside.css'

/* eslint-disable jsx-a11y/anchor-is-valid */

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: 'white',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'red',
    },
    '&:hover fieldset': {
      borderColor: 'yellow',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'white',
    },
    '&.Mui-disabled fieldset': {
      borderColor: 'white',
      borderWidth: '2px', // 이 라인이 테두리 두께를 설정합니다.
    },
    '&.Mui-disabled fieldset-input': {
      color: 'white',
    },
  },
  '& .MuiSvgIcon-root': {
    color: 'white',
    fontSize: '33px',
  },
  '& .Mui-disabled': {
    color: 'white',
    '& .MuiInputLabel-root': {
      color: 'white',
    },
    '& .MuiOutlinedInput-input': {
      color: 'white',
    },
  },
})

const AsideToolbar = () => {
  const {currentUser} = useAuth()
  const cul = window.location.href.split('?')[1]
  const url = qs.parse(cul)

  const location = useLocation()
  const [officeList, setOfficeList] = useState<any>()
  const [originList, setOriginList] = useState<any>()
  const cooperInfo = useSelector((state: any) => state.cooperInfo)
  const [selectedOffice, setSelectedOffice] = useState<any>(null)
  const [selectedOfficeName, setSelectedOfficeName] = useState<any>(null)
  const dispatch = useDispatch()
  const officeInfo = useSelector((state: any) => state.officeInfo)
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const [cooperList, setCooperList] = useState<any>(null)
  const officeHierarchy = useOfficeHierarchy(officeList)
  const getOfficeList = () => {
    axiosWithAuth()
      .get(`/office/${userInfo?.officeId}`)
      .then((res) => {
        const data = res.data.res
        setOriginList(data)
        const transformedData = data.map((el: any) => ({
          label: el?.officeName,
          value: el?.officeId,
        }))
        setOfficeList((prev: any[]) => [...(prev || []), ...transformedData])
      })
      .catch((err) => {})
  }

  const getCooperList = () => {
    axiosWithAuth()
      .get(`${envBackHost}/cooperation/device`)
      .then((res) => {
        const transformedData = res.data.res.map((item: any) => {
          return {label: item.cooperName, value: item.idx}
        })
        setCooperList(transformedData)
      })
  }
  useEffect(() => {
    const office = _.find(originList, (el: any) => {
      return el?.officeId === url?.officeId
    })
    setSelectedOfficeName(office)
  }, [selectedOffice])

  useEffect(() => {
    getOfficeList()
    getCooperList()
  }, [])
  return (
    <>
      <div className='aside-user  align-items-sm-center justify-content-center  p-0'>
        <div className='w-100 mb-4 p-4 '>
          {officeList &&
            userInfo?.accountType !== 'installer' &&
            userInfo?.accountType !== 'customer_client' && (
              <Autocomplete
                disablePortal
                fullWidth
                defaultValue={
                  officeInfo?.value === 'all'
                    ? officeList[0]
                    : {value: officeInfo?.value, label: officeInfo?.label}
                }
                id='choose-office'
                options={officeHierarchy.options}
                disableClearable={true}
                clearText={'초기화'}
                noOptionsText={'검색 결과가 없습니다.'}
                getOptionLabel={(option: any) =>
                  option.label === undefined ? '사업소를 입력해주세요.' : option.label
                }
                filterOptions={officeHierarchy.filterOptions}
                renderOption={officeHierarchy.renderOption}
                // value={selectedOffice}
                onChange={(e, rowValue: any) => {
                  dispatch({type: 'OFFICE_INFO_REQUEST', payload: rowValue})
                }}
                sx={{fontSize: '1.5rem', color: '#fff'}}
                renderInput={(params) => (
                  <div className={'d-flex gap-3'}>
                    <CssTextField
                      {...params}
                      fullWidth
                      label={
                        userInfo?.accountType === 'gov_user' ||
                        userInfo?.accountType === 'gov_admin'
                          ? `자원 구분`
                          : '사업소 선택'
                      }
                      focused
                      placeholder={'검색하거나 선택할 수 있습니다.'}
                      sx={{
                        input: {
                          color: '#fff',
                        },
                      }}
                    />
                  </div>
                )}
              />
            )}
          {userInfo?.accountType === 'installer' ||
            (userInfo?.accountType === 'customer_client' && (
              <div className={'text-white text-center'}>
                <span className={'fw-bold fs-5'}>영아이티와 함께합니다.</span>
              </div>
            ))}
        </div>
        <div className='w-100 mb-4 p-4 '>
          {cooperList &&
            (userInfo.accountType.includes('sys') ||
              userInfo.accountType.includes('gov_admin') ||
              (userInfo.accountType.includes('gov_charge') &&
                (officeInfo.value === '54' ||
                  officeInfo.value === '5400' ||
                  officeInfo.value === '5401')) ||
              userInfo.accountType.includes('gov_coop')) && (
              <Autocomplete
                disablePortal
                fullWidth
                defaultValue={{value: cooperInfo?.value, label: cooperInfo?.label}}
                id='choose-cooper'
                options={cooperList}
                disableClearable={true}
                clearText={'초기화'}
                noOptionsText={'검색 결과가 없습니다.'}
                getOptionLabel={(option: any) =>
                  option.label === undefined ? '구분 자원을 선택해주세요.' : option.label
                }
                /***
                   @todo 텍스트 밀림현상
                   **/
                // value={selectedOffice}
                onChange={(e, rowValue: any) => {
                  dispatch({type: 'COOPER_INFO_REQUEST', payload: rowValue})
                }}
                sx={{fontSize: '1.5rem', color: '#fff'}}
                renderInput={(params) => (
                  <div className={'d-flex gap-3'}>
                    <CssTextField
                      {...params}
                      fullWidth
                      label='단말기 제조사'
                      focused
                      placeholder={'검색하거나 선택할 수 있습니다.'}
                      sx={{
                        input: {
                          color: '#fff',
                        },
                      }}
                    />
                  </div>
                )}
              />
            )}
        </div>
      </div>
    </>
  )
}

export {AsideToolbar}
